import React, { lazy, Suspense, useContext } from 'react';
import { Role } from 'API';
import { UserContext } from 'shared/contexts/UserContext';
import PageTitle from 'components/PageTitle';

const DashboardEmployer = lazy(
  () => import('components/dashboard/DashboardEmployer'),
);

const DashboardFN = lazy(
  () => import('components/dashboard/DashboardFN'),
);

interface Props {
  role: Role.ADMIN | Role.TEAMMEMBER | Role.EMPLOYER | Role.FOREIGNNATIONAL;
}

const DashboardSwitch = ({ role }: Props) => {
  switch (role) {
    case Role.ADMIN:
    case Role.TEAMMEMBER:
    case Role.EMPLOYER:
      return (
        <Suspense fallback={null}>
          <DashboardEmployer />
        </Suspense>
      );
    case Role.FOREIGNNATIONAL:
      return (
        <Suspense fallback={null}>
          <DashboardFN />
        </Suspense>
      );
    default:
      return null;
  }
};

const Dashboard: React.FC = () => {
  const [userState] = useContext(UserContext);
  const { role } = userState;

  return (
    <main className="page-grid__main content">
      <DashboardSwitch role={role} />
      <PageTitle title="Home" />
    </main>
  );
};
export default Dashboard;
